import React, { useContext } from 'react';
import './NeedHelpPage.scss';
import { Link, useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { SiteContext } from '../../../context/SiteContext';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import { getStartQuotePath } from './InsuranceMethods';
import { useLocation } from 'react-router-dom';

type LocationState = {
  voucherReference: string;
};

const ExcessConfirmationPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);
  const { brand } = site;
  const { state } = useLocation();
  const { voucherReference } = state as LocationState;

  const { brandName, brandDisplayFullName } = brand;
  const brandPhoneNumber = brand.brandPhoneNumbers.quotesAndRenewalsNumber;

  const onContinueClick = () => {
    navigate(
      getStartQuotePath(
        site.user.isDealer ?? false,
        site.brand.useAlternateEligibility
      )
    );
  };

  return (
    <div>
      <h4 className='section-header m1-top'>
        Your complimentary Excess return voucher
      </h4>
      <br></br>
      <p>Thank you</p>
      <br></br>
      <p>
        Your excess return voucher {voucherReference} will be emailed to you in
        the next 24 hours. The{' '}
        <Link
          id='lnkTermsAndConditionDocument'
          className='in-text'
          to={PageAbsolutePath.Insurance.TermsAndConditions}>
          Terms and Conditions
        </Link>{' '}
        are provided in your voucher
      </p>
      <h4 className='section-header m1-top'>
        Make the switch to the {brandDisplayFullName} Insurance
      </h4>
      <p>
        If your car insurance is coming up for renewal, why not get a
        competitive online quote today and keep your {brandName} 100%{' '}
        {brandName}. Or call{' '}
        <a className='in-text' href={`tel:${brandPhoneNumber}`}>
          {brandPhoneNumber}
        </a>{' '}
        for our latest insurance offers.
      </p>
      <div className='flex-row form-nav'>
        <ButtonContinue
          name='btn-get-quote'
          text='Get a quote'
          onClick={onContinueClick}
          additionalClassNames='btn-continue'
        />
      </div>
    </div>
  );
};
export default ExcessConfirmationPage;
